import React from "react";
import { useTranslation } from "react-i18next";

import { Eyebrow, KineticTitle, PageMark, Signature, tiltHandlers } from "./GhxpUi";
import { PANELS } from "./ghxpAssets";

// Cena 9 — "Do convite ao encontro. Do encontro à lembrança." (pág. 16).
// Só aparece depois do envio: mostra o universo da marca com os mockups em alta, sem pedir nada.
const ITEMS = [
  { key: "convite", panel: PANELS.convite, position: "50% 50%" },
  { key: "led", panel: PANELS.led, position: "55% 45%" },
  { key: "kit", panel: PANELS.kit, position: "50% 50%" },
];

function GhxpMemory({ onRestart, active, near }) {
  const { t } = useTranslation();

  return (
    <>
      <div className="ghxpStage ghxpStage--bare" aria-hidden="true">
        <div className="ghxpStage__light" />
      </div>
      <span className="ghxpMemory__giant" aria-hidden="true">#GHXP</span>

      <div className="ghxpMemory__content ghxpDepth" data-scrollable="y">
        <div className="ghxpMemory__intro">
          <Eyebrow className="ghxpReveal">{t("ghxp_memory_eyebrow")}</Eyebrow>
          <KineticTitle text={t("ghxp_memory_title")} className="ghxpDisplay ghxpMemory__title" />
          <p className="ghxpMemory__text ghxpReveal">{t("ghxp_memory_text")}</p>
        </div>

        <div className="ghxpMemory__gallery" data-scrollable="x" tabIndex={active ? 0 : -1}>
          {ITEMS.map((item, i) => (
            <div key={item.key} className="ghxpCardIn" style={{ "--i": i }}>
              <figure className="ghxpCard ghxpMemory__panel" {...tiltHandlers}>
                {near && (
                  <img
                    src={item.panel.src}
                    srcSet={item.panel.srcSet}
                    sizes="(min-width: 768px) 24vw, 82vw"
                    width={item.panel.width}
                    height={item.panel.height}
                    alt={t(`ghxp_memory_alt_${i + 1}`)}
                    decoding="async"
                    style={{ objectPosition: item.position }}
                  />
                )}
                <figcaption>{t(`ghxp_memory_caption_${i + 1}`)}</figcaption>
              </figure>
            </div>
          ))}
        </div>
      </div>

      <footer className="ghxpMemory__footer">
        <PageMark className="ghxpMemory__mark" />
        <KineticTitle as="p" text={t("ghxp_tagline")} className="ghxpTagline ghxpMemory__tagline" />
        <div className="ghxpMemory__signature">
          <Signature />
          <button type="button" className="ghxpTextLink" onClick={onRestart}>
            {t("ghxp_back_home")}
          </button>
        </div>
      </footer>
    </>
  );
}

export default GhxpMemory;
